import type { ClientPortfolioDataCommodityServiceEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	getServicesRequestVariant,
	ServicesRequestVariant,
} from "web_myplann/Portfolio/Helpers/commodityServiceBranch";

type ServicesPriceValues = {
	commodityService?: ClientPortfolioDataCommodityServiceEnum | null;
	unitOfMeasurement?: string | null;
	pricePerUnit?: number | null;
	depositAmount?: number | null;
	fixedPriceByFrequency?: number | null;
};

export type ServicesPriceFieldVisibility = {
	showMeteredFields: boolean;
	showFixedPriceField: boolean;
	isReadOnly: boolean;
	unitOfMeasurement: string;
};

export const getServicesPriceFieldVisibility = ({
	commodityService,
	unitOfMeasurement,
	pricePerUnit,
	depositAmount,
	fixedPriceByFrequency,
}: ServicesPriceValues): ServicesPriceFieldVisibility => {
	const variant = getServicesRequestVariant(commodityService);
	const isUntyped = variant === ServicesRequestVariant.Untyped;
	const trimmedUnitOfMeasurement = unitOfMeasurement?.trim() ?? "";

	const hasMeteredValue =
		!!trimmedUnitOfMeasurement || pricePerUnit != null || depositAmount != null;

	return {
		showMeteredFields: isUntyped
			? hasMeteredValue
			: variant === ServicesRequestVariant.Metered,
		showFixedPriceField: isUntyped
			? fixedPriceByFrequency != null
			: variant === ServicesRequestVariant.FixedPrice,
		isReadOnly: isUntyped,
		unitOfMeasurement: trimmedUnitOfMeasurement,
	};
};
